export default function Stepper({ activeIndex }: { activeIndex: number }) {
  return (
    <div className='mb-4 flex justify-center'>
      <ol className='flex w-[350px] items-center space-x-2 rounded-lg border border-gray-200 bg-white p-3 text-center text-sm font-medium text-gray-500 shadow-sm rtl:space-x-reverse dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 sm:space-x-4 sm:p-4 sm:text-base'>
        <li
          className={`flex items-center ${
            activeIndex === 0 ? 'text-blue-600 dark:text-blue-500' : ''
          } `}
        >
          <span
            className={`me-2 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${
              activeIndex === 0 ? 'border-blue-600 dark:border-blue-500' : ''
            }   text-xs `}
          >
            1
          </span>
          Create <span className='ms-1'> Event</span>
          <svg
            className='ms-2 h-3 w-3 rtl:rotate-180 sm:ms-4'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 12 10'
          >
            <path
              stroke='currentColor'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='m7 9 4-4-4-4M1 9l4-4-4-4'
            />
          </svg>
        </li>
        <li
          className={`flex items-center ${
            activeIndex === 1 ? 'text-blue-600 dark:text-blue-500' : ''
          } `}
        >
          <span
            className={`me-2 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${
              activeIndex === 1 ? 'border-blue-600 dark:border-blue-500' : ''
            }   text-xs `}
          >
            2
          </span>
          Add <span className='ms-1'> Alpacas</span>
          {/* <svg
            className="ms-2 h-3 w-3 rtl:rotate-180 sm:ms-4"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 12 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m7 9 4-4-4-4M1 9l4-4-4-4"
            />
          </svg> */}
        </li>
      </ol>
    </div>
  );
}
